import { render } from "./SearchBox.vue?vue&type=template&id=e71cf84c&scoped=true"
import script from "./SearchBox.vue?vue&type=script&lang=js"
export * from "./SearchBox.vue?vue&type=script&lang=js"

import "./SearchBox.vue?vue&type=style&index=0&id=e71cf84c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e71cf84c"],['__file',"src/views/FAQManagement/components/contentComponents/SearchBox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e71cf84c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e71cf84c', __exports__)) {
    api.reload('e71cf84c', __exports__)
  }
  
  module.hot.accept("./SearchBox.vue?vue&type=template&id=e71cf84c&scoped=true", () => {
    api.rerender('e71cf84c', render)
  })

}


export default __exports__